module.exports = __webpack_public_path__ + "static/media/step1.84be6200.png";